import { render } from "./OrderItem.vue?vue&type=template&id=ab69a98a&scoped=true&ts=true"
import script from "./OrderItem.vue?vue&type=script&lang=ts"
export * from "./OrderItem.vue?vue&type=script&lang=ts"

import "./OrderItem.vue?vue&type=style&index=0&id=ab69a98a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab69a98a"]])

export default __exports__